import { useContext, useEffect, useState } from 'react';
import { PedidoFiltroContainer, StyledTable, PedidoVentaContainer } from '../PedidosComponents';
import { columnasDevolucionPie, columnasVentapie, customStyles, opcionesdepagina, } from '../tableOptions';
import { styles } from '../PedidosComponents';
import { makeStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import { FcSearch } from 'react-icons/fc';
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel from '../../../components/generics/tabPanels';
import { PedidosContext } from '../../../context/PedidosContext';

const useStyles = makeStyles(styles);

function PieDeVenta() {
  const { añadirProducto, añadirDevolucion, filteredProducts, devolucionesFiltradas, actualizarListas, buscarPorCodigo } = useContext(PedidosContext);
  const classes = useStyles();
  const [search, setSearch] = useState('');
  const [nombre, setNombre] = useState("");
  const [isFilteringReturns, setIsFilteringReturns] = useState(false);
  const [isFilteringProducts, setIsFilteringProducts] = useState(false)

  //tabs
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  useEffect(() => {
    if (value === 0) setIsFilteringProducts(true);
    if (value === 1) setIsFilteringReturns(true);
    const id = setTimeout(() => {
      buscarPorCodigo(search, value);
      if (value === 0) setIsFilteringProducts(false);
      if (value === 1) setIsFilteringReturns(false);
    }, 700);
    return () => clearTimeout(id);
  }, [search]);

  useEffect(() => {
    const id = setTimeout(() => {
      actualizarListas(nombre, value);
    }, 700);
    return () => clearTimeout(id);
  }, [nombre]);

  return (
    <PedidoVentaContainer>
      <Tabs value={value} indicatorColor="primary" textColor="primary" onChange={handleChange}>
        <Tab label="Productos" />
        <Tab label="Devoluciones" />
      </Tabs>
      <PedidoFiltroContainer>
        <TextField
          variant="standard"
          autoFocus
          className={classes.formControl}
          label='Buscar por codigo'
          id='Buscar'
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
          }}
          InputProps={{
            endAdornment: <FcSearch />,
          }} />
        <TextField
          variant="standard"
          className={classes.formControl}
          label='Buscar por nombre'
          id='BuscarNombre'
          value={nombre}
          onChange={(e) => {
            setNombre(e.target.value);
          }}
          InputProps={{
            endAdornment: <FcSearch />,
          }} />
      </PedidoFiltroContainer>
      <TabPanel value={value} index={0}>
        {!isFilteringProducts && <StyledTable
          columns={columnasVentapie}
          data={filteredProducts}
          customStyles={customStyles}
          pagination
          paginationComponentOptions={opcionesdepagina}
          fixedHeader
          onRowClicked={(row) => {
            añadirProducto(row._id);
            setSearch('');
            setNombre("");
          }
          }
          fixedHeaderScrollHeight='200px'
          dense
          highlightOnHover
          responsive={true}
          noDataComponent={
            <div>No hay informacion disponible para mostrar</div>
          }
        />}
      </TabPanel>
      <TabPanel value={value} index={1}>
        {!isFilteringReturns && <StyledTable
          columns={columnasDevolucionPie}
          data={devolucionesFiltradas}
          customStyles={customStyles}
          pagination
          paginationComponentOptions={opcionesdepagina}
          fixedHeader
          onRowClicked={(row) => {
            añadirDevolucion(row._id);
            setSearch('');
            setNombre("");
          }}
          fixedHeaderScrollHeight='200px'
          dense
          highlightOnHover
          responsive={true}
          noDataComponent={
            <div>No hay informacion disponible para mostrar</div>
          }
        />}
      </TabPanel>
    </PedidoVentaContainer>
  );
}

export default PieDeVenta;
PieDeVenta.propTypes = {};